<button
  #heldTrigger
  [disabled]="!hasHeldTickets"
  [matMenuTriggerFor]="heldTicketsMenu"
  (menuOpened)="onMenuOpen()"
  [ngClass]="
    (heldTriggerBtn && heldTriggerBtn.menuOpen) || !hasHeldTickets
      ? ''
      : 'pulse'
  "
  color="warn"
  mat-icon-button
  matTooltip="Held Tickets — tickets temporarily removed from the solver"
>
  <mat-icon
    fontIcon="fa-pause-circle"
    fontSet="fa-solid"
    style="font-size: 22px"
  ></mat-icon>
  @if (heldCount > 0 && heldCount < 10) {
    <span
      style="
        color: white;
        position: absolute;
        left: 21px;
        font-size: 14px;
        padding-top: 2px;
      "
      >{{ heldCount }}</span
    >
  }
  @if (heldCount >= 10) {
    <span
      style="color: white; position: absolute; left: 16px; font-size: 12px"
      >{{ heldCount }}</span
    >
  }
</button>

<mat-menu
  #heldTicketsMenu="matMenu"
  class="held-tickets-menu"
  xPosition="before"
>
  @if (heldEntries.length === 0) {
    <p style="padding: 10px; margin: 0">No held tickets</p>
  }
  @if (heldEntries.length > 0) {
    <div class="held-header">
      <span>{{ heldCount }} Held Ticket{{ heldCount > 1 ? "s" : "" }}</span>
    </div>
    @for (entry of heldEntries; track entry.visitId) {
      <div class="held-entry" [class.held-entry-placeable]="entry.currentlyPlaceable">
        <div class="held-entry-info">
          <div class="held-entry-ref">
            @if (entry.externalJobRef) {
              <strong>{{ entry.externalJobRef }}</strong>
            } @else {
              <strong>Visit {{ entry.visitId }}</strong>
            }
            <span class="held-entry-badge"
              >{{ entry.ticketIds.length }} ticket{{
                entry.ticketIds.length > 1 ? "s" : ""
              }}</span
            >
            @if (entry.lockedToResourceId) {
              <span class="held-entry-lock-badge">🔒 Locked</span>
            }
          </div>
          <div class="held-entry-reason">
            @if (isVisitInProgress(entry)) {
              <span class="held-in-progress">⚠️ Visit in progress — cannot refer or rebook</span>
            } @else if (entry.currentlyPlaceable) {
              <span class="held-placeable">✅ Ready to re-insert</span>
            } @else if (entry.currentReason) {
              {{ entry.currentReason }}
            } @else {
              {{ entry.extractionReason }}
            }
          </div>
          <div class="held-entry-tickets">
            @for (ticketId of entry.ticketIds; track ticketId) {
              <span
                class="held-ticket-link"
                (click)="openTicketDialog(ticketId)"
                >Ticket {{ ticketId }}</span
              >
            }
          </div>
          <div class="held-entry-meta">
            Held for {{ getTimeSinceExtraction(entry) }} · Checked
            {{ entry.checkCount }} time{{ entry.checkCount !== 1 ? "s" : "" }}
          </div>
        </div>
        <div class="held-entry-actions">
          @if (isVisitInProgress(entry)) {
            <!-- In-progress visits: only Retry or Convert to Lone Worker -->
            <button
              mat-button
              color="primary"
              (click)="reinsertHeldVisit(entry)"
              matTooltip="Re-insert into solver to try again"
            >
              <mat-icon fontIcon="fa-redo" fontSet="fa-solid"></mat-icon>
              Retry
            </button>
            <button
              mat-button
              color="warn"
              (click)="convertToLoneWorker(entry)"
              matTooltip="Remove the unplannable ticket — the other operative continues alone"
            >
              <mat-icon fontIcon="fa-user" fontSet="fa-solid"></mat-icon>
              Convert to Lone Worker
            </button>
          } @else {
            <!-- Normal held tickets: full action set -->
            <button
              mat-button
              color="primary"
              (click)="reinsertHeldVisit(entry)"
              matTooltip="Re-insert into solver to try again"
            >
              <mat-icon fontIcon="fa-redo" fontSet="fa-solid"></mat-icon>
              Retry
            </button>
            <button
              mat-button
              color="primary"
              (click)="openBookingPage(entry)"
              matTooltip="Open booking page to rebook"
            >
              <mat-icon fontIcon="fa-calendar-alt" fontSet="fa-solid"></mat-icon>
              Rebook
            </button>
            @if (entry.lockedToResourceId) {
              <button
                mat-button
                color="accent"
                (click)="unlockHeldVisit(entry)"
                matTooltip="Remove resource lock so solver can assign to any qualifying resource"
              >
                <mat-icon fontIcon="fa-unlock" fontSet="fa-solid"></mat-icon>
                Unlock
              </button>
            }
            <button
              mat-button
              color="warn"
              (click)="referHeldVisit(entry)"
              matTooltip="Refer this visit"
            >
              <mat-icon fontIcon="fa-ban" fontSet="fa-solid"></mat-icon>
              Refer
            </button>
          }
        </div>
      </div>
    }
  }
</mat-menu>
